import axios from 'axios';

interface PowerBITokenResponse {
  reportId: string;
  embedUrl: string;
  accessToken: string;
}

export const reportsService = {
  getEmbedToken: async (reportName: string): Promise<PowerBITokenResponse> => {
    const response = await axios.get<PowerBITokenResponse>(
      `/powerbi/get-token`, 
      { params: { reportName } }
    );
    return response.data;
  }
};